import { Div, Ref } from '@tblabs/truffle';


export class Bar extends Div
{
    constructor(val: Ref<number>, ind: number)
    {
        super();

        this
            .DisplayInlineBlock()
            .Height(2 + (ind * 4))
            .Width(5)
            .MarginLeft(1)
            .When(val, v => +v >= ind, _ => _.Background("#ddd"), _ => _.Background("#444"));
    }
}
